import './App.css';
import React, { lazy, Suspense, useEffect, useMemo } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Career from './pages/Career';
import Claim from './pages/Claim';
// import HealthRenewal from './pages/HealthRenewal';
import MotorRenewal from './pages/MotorRenewal';
import Rec from './components/Footer/Recipt';
import Terms from 'components/Footer/Terms';
import Privacy from 'components/Footer/Privacy';
import Shipping from 'components/Footer/Shipping';
import About from 'pages/About/About';
import ContactUs from 'pages/ContactUs/ContactUs';
import Business from 'pages/Business.jsx';

import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { authRoutes, noAuthRoutes } from './utils/constants/routes.config';
import Congratulations from 'pages/Insurance/Congratulations';
import { POSP } from './utils/constants';
import Loader from './components/Skeleton/Spinner';
import { fetchRoutes } from './utils/functions/getAuthRoutes';
import Refund from 'components/Footer/Refund';
import { UserProfile } from 'pages/UserProfile';
import PageUnderConstruction from 'pages/PageUnderConstruction/PageUnderConstruction';
import CompanyRenewalLinks from 'pages/CompanyRenewalLinks';
import UpcomingRenewals from 'pages/UpcomingRenewals';
import Home from 'pages/Home/Home';
import Login from 'pages/Login/Login';
import AgreementProcess from 'components/Success/AgreementProcess';
import AgreementPage from 'components/Agreement/Agreement';
import AgreementSubmitted from 'components/Agreement/AgreementSubmitted';
import Error404 from 'pages/NotFound/404';
import Certificate from 'components/Agreement/Certificate';

const Layout = lazy(() => import('./components/Layout/Layout'));
const AuthRoute = lazy(() => import('./components/AuthRoute/AuthRoute'));

function App() {
  const { auth: isAuth, profileTrackerCode } = useSelector(
    (state) => state.user
  );

  const links = useMemo(
    () => (isAuth ? fetchRoutes(authRoutes, profileTrackerCode) : noAuthRoutes),
    [isAuth, profileTrackerCode]
  );

  const renderRoutes = (linkObj, parentPath, key, isChild = false) => {
    const { path, component: Component, children = [] } = linkObj;
    let joinedPath = parentPath === null ? path : [parentPath, path].join('/');
    let uniqueId = joinedPath + key;
    let comp;
    let WrappedComponent =
      parentPath === null ? (
        <AuthRoute>
          <Component />
        </AuthRoute>
      ) : (
        <Layout>
          <AuthRoute>
            <Component />
          </AuthRoute>
        </Layout>
      );
    if (children.length === 0) {
      comp = (
        <Route key={uniqueId} path={joinedPath} element={WrappedComponent} />
      );
    } else {
      comp = (
        <Route key={uniqueId} path={joinedPath} element={WrappedComponent}>
          {children.map((child, i) =>
            renderRoutes(child, null, uniqueId + i, true)
          )}
        </Route>
      );
    }
    return comp;
  };

  return (
    <>
      <div className="min-h-screen relative">
        {/* every new page will scroll to top on path change */}
        <ScrollToTop />
        <Header />
        <div className="">
          <Suspense
            fallback={
              <div className="flex justify-center items-center">
                <div className="h-9 w-9">
                  <Loader />
                </div>
              </div>
            }
          >
            <Routes>
              <Route
                path="/loading"
                element={
                  <div className="h-9 w-9">
                    <Loader />
                  </div>
                }
              />
              <Route
                path="/"
                element={
                  <div>
                    <Home />
                  </div>
                }
              />
              <Route
                path="/career"
                element={
                  <div>
                    <Career />
                  </div>
                }
              />
              <Route
                path="/profile"
                element={
                  <div>
                    <UserProfile />
                  </div>
                }
              />
              <Route
                path="/renewal/company-renewal-links"
                element={
                  <div>
                    <CompanyRenewalLinks />
                  </div>
                }
              />
              <Route
                path="/renewal/upcoming-renewals"
                element={
                  <div>
                    <UpcomingRenewals />
                  </div>
                }
              />
              <Route
                path="/posp/training/process-agreement"
                element={
                  <div>
                    <AgreementProcess />
                  </div>
                }
              />
              <Route
                path="/posp/training/certificate"
                element={
                  <div>
                    <Certificate />
                  </div>
                }
              />
              <Route
                path="/posp/training/agreement/:id"
                element={
                  <div>
                    <AgreementPage />
                  </div>
                }
              />
              <Route
                path="/posp/error404"
                element={
                  <div>
                    <Error404 />
                  </div>
                }
              />
              <Route
                path="/posp/training/submited-agreement"
                element={<AgreementSubmitted />}
              />
              <Route
                path="/privacypolicy"
                element={
                  <div>
                    <Privacy />
                  </div>
                }
              />{' '}
              <Route
                path="/under-construction"
                element={
                  <div>
                    <PageUnderConstruction />
                  </div>
                }
              />{' '}
              <Route
                path="/shppingpolicy"
                element={
                  <div>
                    <Shipping />
                  </div>
                }
              />
              <Route
                path="/refund"
                element={
                  <div>
                    <Refund />
                  </div>
                }
              />
              <Route
                path="/about"
                element={
                  <div>
                    <About />
                  </div>
                }
              />
              <Route
                path="/contact"
                element={
                  <div>
                    <ContactUs />
                  </div>
                }
              />
              <Route
                path="/claim"
                element={
                  <div>
                    <Claim />
                  </div>
                }
              />
              <Route
                path="/rec"
                element={
                  <div>
                    <Rec />
                  </div>
                }
              />
              <Route
                path="/posp/business"
                element={
                  <div>
                    <Business />
                  </div>
                }
              />
              {isAuth
                ? links.map((link, linkInd) =>
                    renderRoutes(link, POSP, linkInd)
                  )
                : links.map((link) => (
                    <Route
                      key={link.path}
                      path={link.path}
                      element={
                        <div>
                          <link.component />
                        </div>
                      }
                    />
                  ))}
              <Route
                path="/policy/payment/success"
                element={
                  <Congratulations
                    checkPaymentStatus={{ flag: true, status: 1 }}
                  />
                }
              />
              <Route
                path="/policy/payment/failure"
                element={<p>Payment Failed!!</p>}
              />
            </Routes>
          </Suspense>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
